import { getAllLocales, getLocale, setLocale } from "@umijs/max";
import { Dropdown } from "antd";
import React, { useState } from "react";

type LocaleKey = "ja-JP" | "en-US" | "zh-CN" | "zh-TW";

// LABELS[displayLocale][targetLocale] — every option's name written in the
// current UI language, matching how Apple/Microsoft localize their language pickers.
const LABELS: Record<LocaleKey, Record<LocaleKey, string>> = {
  "ja-JP": {
    "ja-JP": "日本語",
    "en-US": "英語",
    "zh-CN": "中国語(簡体字)",
    "zh-TW": "中国語(繁体字)",
  },
  "en-US": {
    "ja-JP": "Japanese",
    "en-US": "English",
    "zh-CN": "Simplified Chinese",
    "zh-TW": "Traditional Chinese",
  },
  "zh-CN": {
    "ja-JP": "日语",
    "en-US": "英语",
    "zh-CN": "简体中文",
    "zh-TW": "繁体中文",
  },
  "zh-TW": {
    "ja-JP": "日語",
    "en-US": "英語",
    "zh-CN": "簡體中文",
    "zh-TW": "繁體中文",
  },
};

const labelFor = (display: string, target: string) => {
  const row = LABELS[display as LocaleKey];
  return row?.[target as LocaleKey] ?? target;
};

export const SelectLang: React.FC = () => {
  const [selectedLang, setSelectedLang] = useState(() => getLocale());

  const allLocales = getAllLocales();

  const menuItems = allLocales.map((locale) => ({
    key: locale,
    label: labelFor(selectedLang, locale),
  }));

  return (
    <Dropdown
      menu={{
        selectedKeys: [selectedLang],
        items: menuItems,
        onClick: ({ key }) => {
          setLocale(key, true);
          setSelectedLang(key);
        },
      }}
      placement="bottomRight"
    >
      <span className="header-action">
        <svg
          viewBox="0 0 24 24"
          focusable="false"
          width="1em"
          height="1em"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z" />
        </svg>
      </span>
    </Dropdown>
  );
};
